import React from 'react'
import { useParams } from 'react-router-dom'

import { ArticleDetail } from './ArticleDetail'
import { Attachment } from './Attachment'
import { DataForDeliveryForecastDespatchAdviceData } from './DataForDeliveryForecastDespatchAdvice'
import { ForecastDeliveryScheduleInformation } from './ForecastDeliveryScheduleInformation'
import { Header } from './Header'
import { PackagedQuantityValidation } from './PackagedQuantityValidation'
import { ShippingDetailsData } from './ShippingDetails'
import { Title } from './Title'

export const DeliveryForecastDespatchAdvice: React.FC = () => {
  const { id } = useParams()

  if (!id) return <></>

  return (
    <>
      <Title despatchAdviceId={id} isConfirmationActive={true} />

      <PackagedQuantityValidation despatchAdviceId={id} />

      <Header despatchAdviceId={id} />

      <ForecastDeliveryScheduleInformation despatchAdviceId={id} />

      <DataForDeliveryForecastDespatchAdviceData despatchAdviceId={id} />

      <ArticleDetail despatchAdviceId={id} />

      <ShippingDetailsData despatchAdviceId={id} />

      <Attachment despatchAdviceId={id} />
    </>
  )
}
